import { render, staticRenderFns } from "./matrixCode.vue?vue&type=template&id=cfdce93a&scoped=true"
import script from "./matrixCode.vue?vue&type=script&lang=js"
export * from "./matrixCode.vue?vue&type=script&lang=js"
import style0 from "./matrixCode.vue?vue&type=style&index=0&id=cfdce93a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdce93a",
  null
  
)

export default component.exports